import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface EmployeeImageByIdGetter {
  (employeeId: string): Observable<Blob>;
}

export const EmployeeImageToken = new InjectionToken<EmployeeImageByIdGetter>(
  'EmployeeImageToken'
);
